import React from 'react';
import { Statistic, Row, Col } from 'antd';
import { Tiny } from '@ant-design/plots';

const config = {
  height: 30,
  shapeField: 'smooth',
  xField: 'index',
  yField: 'value',
  style: {
    lineWidth: 2,
  },
  padding: 2,
};

const DashboardStatistics = ({ statistics }) => (
  <Row gutter={[16, 16]}>
    {statistics.map((statistic, index) => (
      <Col key={index} flex="1" align="center">
        <Statistic {...statistic} />
        {statistic.chartData?.some(x => x) && <Tiny.Line {...config} data={statistic.chartData.map((value, i) => ({ value, index: i }))} />}
      </Col>
    ))}
  </Row>
);

export default DashboardStatistics;
